import React, { useRef } from "react"
import { useClickOutside } from "../../../hooks/useClickOutside"

import type { ModalProps } from "./modal.interfaces"
import { ModalWrapper } from "./modal.styled"
import useWindowSize from "../../../hooks/useWindowSize"

const Modal: React.FC<ModalProps> = ({
  onClose,
  customstyles = {},
  isOpen,
  isOutsideClickEnabled = true,
  children
}) => {
  const modalWrapperRef = useRef<HTMLDivElement>(null)
  const { screenSize } = useWindowSize()
  const handleOutsideClick = () => {
    if (isOutsideClickEnabled) {
      onClose()
    }
  }
  useClickOutside(modalWrapperRef, handleOutsideClick)
  const isSmallWindowHeight = React.useMemo(
    () => 570 > screenSize.height || screenSize.width < 1024,
    [screenSize.height, screenSize.width]
  )
  if (!isOpen) return null

  return (
    <ModalWrapper
      isSmallWindowHeight={isSmallWindowHeight}
      style={customstyles?.wrapperStyles}
      ref={modalWrapperRef}
    >
      {children}
    </ModalWrapper>
  )
}

export default Modal
